import React,{FC} from 'react'
import { Grid,Typography,Stack,ToggleButtonGroup,ToggleButton,Theme} from '@mui/material';
import { createStyles, makeStyles } from "@mui/styles";
import CalendarStrip from './components/callenderStrip';
import { VisitType } from 'utils/constants';

const useStyles = makeStyles((theme:Theme) =>
    createStyles({
        callenderMain:{
            [theme.breakpoints.up('md')]:{
                display:"flex",
                justifyContent:"space-between"
            },
            
        },
        visitTypeMain:{
            [theme.breakpoints.up('md')]:{
                width:"20%"
            }
        },
        ToggleButton:{
            [theme.breakpoints.up('md')]:{
                width:"160px !important" 
            },
            [theme.breakpoints.down('lg')]:{
                width:"50% !important" 
            },
            padding:"3px !important"
        },
        ToggleButtonContentBody:{
            width:"100%",
            height:"100%",
            borderRadius:"3px",
            display:"flex",
            alignItems:"center",
            justifyContent:"center"
        },
        ToggleButtonContent:{
            fontSize:"1rempx !important",
            fontFamily:"AkkuratLL !important",
            textTransform: 'none'
        },
        calendarStripMain:{
            [theme.breakpoints.up('lg')]:{
                width:"69.5% !important"
            },
             [theme.breakpoints.up('xl')]:{
                width:"70.5% !important"
            },
             [theme.breakpoints.down('lg')]:{
                width:"70% !important"
            },
            
            [theme.breakpoints.down('md')]:{
                width:"100% !important"
            },
        }

}));

interface props{
setIsVirtualVisit?:any
}

const DRCallender:FC<props>=({setIsVirtualVisit})=> {
  const classes = useStyles();
  const [visitType, setVisitType] = React.useState(VisitType.IN_PERSON);
  const onChange = (
    event: React.MouseEvent<HTMLElement>,
    vType: string | null,
  ) => {
    if (vType !== null) {
        setVisitType(vType);
        setIsVirtualVisit(vType === VisitType.VIRTUAL_VISIT);
    }
  };

  return (
    <Grid className={classes.callenderMain}>
        <Grid className={classes.visitTypeMain}>
            {/* <Stack direction="row" >
                <ToggleButtonGroup
                    value={visitType}
                    exclusive
                    onChange={onChange}
                    aria-label="text alignment"
                    sx={{ width: "100%", height: "36px !important",
                        backgroundColor: "#e0e0e0", // Set background color for the entire group
                        '& .MuiToggleButton-root': {
                          border: 'none', // Remove borders from the buttons
                          backgroundColor: "#e0e0e0", // Set the same background color for the buttons
                          '&.Mui-selected': {
                            backgroundColor: "#e0e0e0", 
                            color:"#079cb2!important"
                          },
                          '&:hover': {
                            backgroundColor: "#d0d0d0", // Optional: Set a different color for hover state
                          },
                        },
                    }}

                    >
                    <ToggleButton value={VisitType.IN_PERSON} aria-label="left aligned" className={classes.ToggleButton}>
                        <Grid sx={{backgroundColor:`${visitType==VisitType.IN_PERSON?"#fff":"transparent"}`}} className={classes.ToggleButtonContentBody}>
                            <Typography className={classes.ToggleButtonContent} sx={{color:`${visitType==VisitType.IN_PERSON && ""}`}}>
                              {VisitType.IN_PERSON}
                            </Typography>
                        </Grid>
                    </ToggleButton>
                    <ToggleButton value={VisitType.VIRTUAL_VISIT} aria-label="right aligned" className={classes.ToggleButton}>
                        <Grid sx={{backgroundColor:`${visitType==VisitType.VIRTUAL_VISIT?"#fff":"transparent"}`}} className={classes.ToggleButtonContentBody}>
                             <Typography className={classes.ToggleButtonContent}>
                              {VisitType.VIRTUAL_VISIT}
                            </Typography>
                        </Grid>
                    </ToggleButton>
                </ToggleButtonGroup>
            </Stack> */}
        </Grid>
        <Grid className={classes.calendarStripMain}>
            <CalendarStrip></CalendarStrip>
        </Grid>
    </Grid>
  )
}

export default DRCallender